import { useQuery } from "react-query";

import { makeRequest } from "../../util";
import { WebTrackerReportResponse } from "../types";
import { WebTrackerReportCompleteFilter } from "../ReportAdminDashboard";

export default function useFetchLatestReports(
  completeFilter: WebTrackerReportCompleteFilter = "Complete",
  domain: string | null = null,
  limit: number = 20,
  offset: number = 0,
  sortBy: "domain" | "startedAt" = "domain",
  sortDir: "asc" | "desc" = "asc"
) {
  return useQuery<WebTrackerReportResponse>(
    [
      "web_tracker_latest_reports",
      completeFilter,
      domain,
      limit,
      offset,
      sortBy,
      sortDir,
    ],
    async () => {
      const res = await makeRequest<WebTrackerReportResponse>(
        "web_tracker_latest_reports",
        {
          completeFilter,
          domain,
          limit,
          offset,
          sortBy,
          sortDir,
        }
      );

      return {
        ...res.data,
        reports: res.data.reports.map((r) => {
          return {
            ...r,
            startedAt: new Date(r.startedAt),
            finishedAt: r.finishedAt ? new Date(r.finishedAt) : undefined,
          };
        }),
      };
    }
  );
}
